export const previewActionStyles = {
  padding: '12px 14px 0',
};
